import { render, staticRenderFns } from "./EditSelector.vue?vue&type=template&id=04604ceb&"
import script from "./EditSelector.vue?vue&type=script&lang=ts&"
export * from "./EditSelector.vue?vue&type=script&lang=ts&"
import style0 from "./EditSelector.vue?vue&type=style&index=0&id=04604ceb&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports